module.exports = __webpack_public_path__ + "static/processing-35a8026ef0d4f4348d4cce0bd9976f42.svg";